import React from "react";
import { Button } from "../../components/button.tsx";
import { Section } from "../../components/section.tsx";

interface DangerSectionProps {
  appName: string;
  onDelete: () => void;
}

export function DangerSection({ appName, onDelete }: DangerSectionProps) {
  function handleClick() {
    if (
      !confirm(
        `Delete "${appName}"? This will remove all of its users and break any integrations using its client_id. This cannot be undone.`,
      )
    ) {
      return;
    }
    onDelete();
  }

  return (
    <Section title="Danger zone">
      <div className="flex items-center justify-between gap-4">
        <div className="text-sm text-muted">
          Delete this application and all of its users. This cannot be undone.
        </div>
        <Button variant="danger" onClick={handleClick}>
          Delete application
        </Button>
      </div>
    </Section>
  );
}
